// 用户信息
<template>
  <div class="information">
    <van-nav-bar :title="$t('menu.information')" @click-left="goBack" left-arrow fixed placeholder>
    </van-nav-bar>
    <div style="margin-top: 30px;">
      <van-cell-group inset :border="false">
        <van-cell class="flex align-center" title="Profile photo" value-class="content" is-link :border="false">
          <template>
            <div class="flex justify-end align-center">
              <van-uploader
                v-model="file"
                accept="image/jpeg"
                :max-count="1"
                preview-size="50px"
                :after-read="afterRead" />
            </div>
          </template>
        </van-cell>
        <van-cell
          class="flex align-center"
          title="Email"
          :value="userInfo.email"
          value-class="content"
          is-link
          :border="false"
        />
        <van-cell
          class="flex align-center"
          title="Nick name"
          :value="userInfo.name"
          value-class="content"
          is-link
          :border="false"
          @click="showName = true; name = userInfo.name"
        />
        <van-cell
          class="flex align-center"
          title="Date of birth"
          :value="userInfo.birthDate"
          value-class="content"
          is-link
          :border="false"
          @click="showBirth = true"
        />
        <van-cell
          class="flex align-center"
          title="Area"
          :value="userInfo.countriesAndRegions"
          value-class="content"
          is-link
          :border="false"
          @click="showArea = true"
        />
      </van-cell-group>
    </div>
    <div class="btn">
      <van-button class="submit" block round size="large" color="linear-gradient(30deg, #3EE191, #24DEDD)" type="info" @click="operate(0, 'swicth account')">
        {{ $t('register.switch') }}
      </van-button>
      <van-button style="margin-top: 25px;" class="cancel" block round size="large" color="#282828" type="info" plain native-type="button" @click="operate(1, 'logout')">
        {{ $t('register.logout') }}
      </van-button>
    </div>

    <van-popup v-model="showName" round position="center">
      <div class="card name-wrapper">
        <div class="dialog__title">
          Edit
        </div>
        <div class="dialog__content">
          <div>Nick name</div>
          <van-field v-model="name" placeholder="Please input your nick name" />
        </div>
        <div class="dialog__footer">
          <div class="flex justify-end">
            <div @click="nameConfirm">Determine</div>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showBirth" round position="bottom">
      <van-datetime-picker
        :value="new Date(userInfo.birthDate)"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="showBirth = false"
        @confirm="birthConfirm"
      />
    </van-popup>

    <van-popup v-model="showArea" round position="bottom">
      <van-picker
        show-toolbar
        :columns="areaList"
        value-key="dictLabel"
        :default-index="areaList.findIndex(item => item.value === userInfo.countriesAndRegions)"
        @cancel="showArea = false"
        @confirm="areaConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import TabBar from '@/components/tab-bar'
import { logout, getArea, editCustomerInfo, editCustomerHead, customerInfo } from '@/api'
export default {
  name: 'Information',
  components: {
    TabBar
  },
  data () {
    return {
      showName: false,
      showBirth: false,
      showArea: false,
      userInfo: {},
      file: [],
      areaList: [],
      minDate: new Date('1960-01-01'),
      maxDate: new Date(),
      name: ''
    }
  },
  computed: {
    token () {
      return this.$store.state.user.token
    }
  },
  mounted () {
    if (this.token) {
      this.userInfo = this.$store.state.user.userInfo
      this.file.push({
        url: this.$store.state.user.userInfo.headPortrait
      })
    }
    getArea().then(res => {
      console.log(res)
      this.areaList = res.data
    })
  },
  methods: {
    // 退出或切换账号
    operate (isLogout, message) {
      this.$dialog.alert({
        title: 'Tips',
        message: `Are you sure to ${message}`,
        showCancelButton: true,
        confirmButtonText: 'Determine',
        confirmButtonColor: '#1989fa',
        cancelButtonColor: '#1989fa'
      }).then(() => {
        logout().then(res => {
          sessionStorage.removeItem('token')
          this.$store.commit('setToken', '')
          sessionStorage.removeItem('userInfo')
          this.$store.commit('setUserInfo', {})
          if (isLogout) {
            this.$router.push('home')
          } else {
            this.$router.push('login')
          }
        })
      })
    },
    // 上传头像后
    afterRead (file) {
      console.log(file)
      this.file = [file]
      console.log(this.file)
      this.save()
    },
    // 地区确认
    areaConfirm (val) {
      console.log(val)
      this.userInfo.countriesAndRegions = val.dictLabel
      this.showArea = false
      this.save()
    },
    // 生日确认
    birthConfirm (val) {
      console.log(val)
      this.userInfo.birthDate = this.$moment(val).format('YYYY-MM-DD')
      this.showBirth = false
      this.save()
    },
    // 昵称确认
    nameConfirm () {
      this.userInfo.name = this.name
      this.showName = false
      this.save()
    },
    // 保存顾客信息
    async save () {
      // 修改顾客信息
      await editCustomerInfo({
        name: this.userInfo.name,
        birthDate: this.userInfo.birthDate,
        countriesAndRegions: this.userInfo.countriesAndRegions
      }).then(res => {
        this.$toast(res.msg)
      })
      // 更换头像
      if (this.file[0].file) {
        await editCustomerHead(this.file[0].file)
      }
    },
    goBack () {
      // 更新最新信息
      customerInfo().then(res => {
        console.log('顾客信息', res.data)
        sessionStorage.setItem('userInfo', JSON.stringify(res.data))
        this.$store.commit('setUserInfo')
        this.$router.go(-1)
      })
    }
  }
}
</script>

<style lang="less">
  .information {
    .van-cell-group {
      background: transparent;
      .van-cell {
        background: transparent;
        line-height: 100px;
      }
      .content {
        flex: 2;
        font-size: 20px;
        white-space: nowrap;
        color: #000;
        font-weight: bold;
      }
    }
    .btn {
      position: absolute;
      width: 100%;
      bottom: 80px;
      box-sizing: border-box;
      padding: 50px;
    }
  }
  .name-wrapper {
    width: 75vw;
    height: 360px;
    overflow: hidden;
    box-sizing: border-box;
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .dialog__title {
      font-size: 40px;
      font-weight: bold;
    }
    .dialog__content {
      font-size: 28px;
      .van-cell {
        padding: 30px 0 0;
        border-bottom: 4px solid #333;
      }
      margin-bottom: 20px;
    }
    .dialog__footer {
      font-weight: bold;
      font-size: 28px;
      color: #1989fa;
    }
  }
</style>
